import React from 'react';
import styled from 'styled-components';
import { Row, Column } from 'rebass';
import PropTypes from 'prop-types';
import { onlyUpdateForKeys } from 'recompose';

import { SelectButtonContainer } from './SelectButtonContainer';

const Wrapper = styled.div`
  overflow: hidden;
  padding: 0px 27px 0;

  div{
    padding: 0;
    margin: 0;

    div{
      margin: 0 3px;
    }
  }
`;

const DepartureSelectorGroup = onlyUpdateForKeys(['options'])(({ options }) => (
  <Wrapper>
    <Row>
      {
        options.length > 1 ?
        options.map((id, i) => (
          <Column key={id}>
            <SelectButtonContainer
              id={id}
              first={i === 0}
              last={i === options.length - 1}
            />
          </Column>
        )) : null
      }
    </Row>
  </Wrapper>
));

DepartureSelectorGroup.propTypes = {
  options: PropTypes.array,
};
DepartureSelectorGroup.defaultProps = {
  options: [],
};

export default DepartureSelectorGroup;



// WEBPACK FOOTER //
// ./src/components/organisms/DepartureSelectorGroup/index.js